import { VisitSettlement } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { VisitDetailsFormBean } from './visitDetails.types';

export const createVisitDetailsFormBean = (
   data: Omit<VisitDetailsFormBean, 'practitioner'>,
   visitSettlement: VisitSettlement | null
): VisitDetailsFormBean | undefined => {
   const { beginDate, endDate, patient } = data;
   const practitioner = visitSettlement?.medicalServicesPerformedByPractitioner;

   return {
      patient: patient,
      beginDate: beginDate,
      endDate: endDate,
      practitioner: practitioner
         ? {
              firstName: practitioner.firstName.asString(),
              lastName: practitioner.lastName.asString(),
              specialtyNames: practitioner.specialtyNames,
           }
         : undefined,
   };
};
